import {
    LibBottomToolbarBottomConfig,
    LibBottomToolbarBottomConfigType
} from "../../../../../tal-library/lib-bottom-toolbar/lib-bottom-toolbar.component";
import {CONSTANT} from "../../../common/constant/constant";
import {
    BUTTON_ICON_POSITION,
    BUTTON_SUB_TYPE,
    BUTTON_TYPE
} from "../../../../../tal-library/button/lib-button/lib-button.component";
import {NOTIFICATION_EVENT_TYPE, NotificationOutDto} from "../service/notification.service";

export class NotificationUtil {
    private static notificationUtil: NotificationUtil;
    
    public static getInstance(): NotificationUtil {
        if (!NotificationUtil.notificationUtil) {
            NotificationUtil.notificationUtil = new NotificationUtil();
        }
        return NotificationUtil.notificationUtil;
    }

    getDescription(notificationOutDto: NotificationOutDto): string {
        if (notificationOutDto?.message) {
            return notificationOutDto.message;
        }
        switch (notificationOutDto?.notificationEventType) {
            case NOTIFICATION_EVENT_TYPE.APPLICATION_ACCEPTED :
                return `The candidate has shown interest in ${notificationOutDto?.jobPostName} You can now engage or schedule an interview.`;
            case NOTIFICATION_EVENT_TYPE.APPLICATION_DECLINED :
                return `It seems the candidate may not be currently interested in opportunities related to the ${notificationOutDto?.jobPostName} role.`;
            case NOTIFICATION_EVENT_TYPE.CHAT_MESSAGE:
                return notificationOutDto?.comment || 'New message';
            default:
                return `Message : ${notificationOutDto?.message}`;
        }
    }

    getTitle(notificationOutDto: NotificationOutDto): string {
        if (notificationOutDto?.title) {
            return notificationOutDto.title;
        }
        switch (notificationOutDto?.notificationEventType) {
            case NOTIFICATION_EVENT_TYPE.APPLICATION_ACCEPTED :
                return ` 🎉 Good News!  ${notificationOutDto?.applicantName} Accepted Your Invitation`;
            case NOTIFICATION_EVENT_TYPE.APPLICATION_DECLINED :
                return ` 📣 ${notificationOutDto?.applicantName} has declined your invitation`;
            case NOTIFICATION_EVENT_TYPE.CHAT_MESSAGE:
                return `💬 New message from ${notificationOutDto?.applicantName ?? 'someone'}`;
            default:
                return `Message : ${notificationOutDto?.message}`;
        }
    }

    getLibBottomToolbarBottomConfig(): LibBottomToolbarBottomConfig[] {
        return [
            {
                id: CONSTANT.MARK_ALL_AS_READ,
                type: LibBottomToolbarBottomConfigType.BUTTON,
                iconClass: 'ti ti-checks text-2xl',
                iconPosition: BUTTON_ICON_POSITION.BEFORE,
                buttonText: 'Mark all as read',
                tooltip: 'Mark all as read',
                buttonType: BUTTON_TYPE.BASIC,
                buttonSubType: BUTTON_SUB_TYPE.SECONDARY,
            } as LibBottomToolbarBottomConfig,
            {
                id: CONSTANT.CLEAR_ALL,
                type: LibBottomToolbarBottomConfigType.BUTTON,
                iconClass: 'ti ti-clear-all text-2xl',
                iconPosition: BUTTON_ICON_POSITION.BEFORE,
                buttonText: 'Clear All',
                tooltip: 'Clear All',
                buttonType: BUTTON_TYPE.LARGE,
                buttonSubType: BUTTON_SUB_TYPE.DANGER,
            } as LibBottomToolbarBottomConfig
        ];
    }
}
